import { createApp } from "vue";
import { createPinia } from "pinia";
import "./style.css";
// import "./theme/outtailwind.scss";
import App from "./App.vue";
import router from "./routers";
import VConsole from "vconsole";
import { middleEllipsisMulti } from "@/directive/middleEllipsisMulti";

new VConsole();

(function flexible() {
  if (window.location.pathname === "/agreement") {
    return;
  }
  const html = document.documentElement;
  const dpr = window.devicePixelRatio || 1;
  html.setAttribute("data-dpr", dpr);

  function setRem() {
    let isMobile = window.innerWidth < 640; // 假设 768px 是移动端的断点
    let isPad = window.innerWidth >= 640 && window.innerWidth < 1000; // 假设 1000 是平板的断点
    if (isMobile) {
      // m
      const width = html.clientWidth;
      const rem = width / 11;
      html.style.fontSize = rem + "px";
    } else if (isPad) {
      // pad
      const width = html.clientWidth;
      const rem = width / 18;
      html.style.fontSize = rem + "px";
    } else {
      // PC
      const width = html.clientWidth;
      const rem = width / 45;
      html.style.fontSize = rem + "px";
    }
  }

  setRem();

  window.addEventListener("resize", setRem);
  window.addEventListener("pageshow", function (e) {
    if (e.persisted) {
      setRem();
    }
  });
})();

const app = createApp(App);
const pinia = createPinia();
middleEllipsisMulti(app);

app.use(router).use(pinia).mount("#app");
